<template>
  <v-btn icon @click="prevTune" :disabled="disabledFlag" :class="nowPlayingIndex">
    <v-icon>skip_previous</v-icon>
  </v-btn>
</template>
<script>
export default {
  name: 'PlayerPrevBtn',
  data () {
    return {
      disabledFlag: true
    }
  },
  computed: {
    nowPlayingIndex () {
      // 「検索結果」再生の場合、１曲目の場合 Prev ボタンを disable
      let nowIndex = Number(this.$store.getters['musicPlayerModuleGetNowPlayTuneData'].index)
      let playlistType = this.$store.getters['musicPlayerModuleGetNowPlayListType']
      if (playlistType === 'search' && nowIndex === 0) {
        this.changeDisabledFlag(true)
      } else {
        this.changeDisabledFlag(false)
      }
      return nowIndex
    }
  },
  methods: {
    prevTune () {
      this.$store.dispatch('musicPlayerModuleSetPrevPlayTuneData')
      let audio = document.querySelector('#audio')
      if (this.$store.getters.musicPlayerModuleGetIsPlaying) {
        const audioPlay = function () {
          audio.play()
        }
        setTimeout(audioPlay, 10)
      }
    },
    changeDisabledFlag (flag) {
      this.disabledFlag = flag
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/atoms/PlayerPrevBtn.vue